import type { ExportNoteEntry } from "../exportFloorPlanToPdf";
import type { BuildNoteExportEntries } from "./types";

export const buildNoteExportEntries: BuildNoteExportEntries = ({
  detectedObjects,
  locale,
  t,
}) => {
  const dateFormat = new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  });
  const entries: ExportNoteEntry[] = [];
  for (const element of detectedObjects) {
    const note = element.note;
    if (note === null) continue;
    // Same rule as the note byline in the app: an edited note shows only its edit time.
    const isEdited = note.updatedAt !== note.createdAt;
    const date = dateFormat.format(
      new Date(isEdited ? note.updatedAt : note.createdAt),
    );
    entries.push({
      objectId: element.id,
      groupLabel: element.group_id,
      rgb: element.rgb,
      bbox: element.bbox,
      author: note.createdBy ?? t("smartSurveyor.history.admin"),
      dateLabel: isEdited
        ? t("smartSurveyor.elementDetails.note.editedAt", { date })
        : date,
      content: note.content,
    });
  }
  return entries;
};
